import { IonContent } from '@ionic/react';
import React from 'react';

import { PAYMENT_SECTION_ID } from '@/constants';
import { PaymentModal } from '@/modals/Payment';
import { webCampaign } from '@/modules/webCampaign';
import { scrollToById } from '@/utils/scrollToById';

import { PageStyles } from './Devmode.styles';
import { PaymentDescription } from './sections/PaymentDescription';
import { DevmodePaymentMethodSelection } from './sections/PaymentMethodSelection';
import { DevmodeSelectPlan } from './sections/SelectPlan';
import { Title } from './sections/Title';

const PaywallDevmode: React.FC = () => {
  return (
    <PageStyles theme={webCampaign.getStaticTheme()}>
      <IonContent>
        <Title />

        <DevmodeSelectPlan
          title={null}
          vipTitle="One Day VIP"
          buttonProps={{
            text: 'GET PREMIUM',
            onClick: () => scrollToById(PAYMENT_SECTION_ID),
          }}
        />

        <PaymentDescription />

        <DevmodePaymentMethodSelection />
      </IonContent>

      <PaymentModal />
    </PageStyles>
  );
};

export default PaywallDevmode;
